import { render, staticRenderFns } from "./ProductNav.vue?vue&type=template&id=b0e32316&scoped=true"
import script from "./ProductNav.vue?vue&type=script&lang=ts"
export * from "./ProductNav.vue?vue&type=script&lang=ts"
import style0 from "./ProductNav.vue?vue&type=style&index=0&id=b0e32316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e32316",
  null
  
)

export default component.exports